import {DeclarationData} from "../types/declaration-modal.types";

export const defaultDeclarationData: DeclarationData = {
  id: 0,
  declarationNumber: 'Новая',
  comment: ''
}
